export function getNameAndAlias(fieldName: string): { name: string; alias: string } {
  const splitted = fieldName.split('.')
  if (splitted.length > 1) {
    const alias = splitted[0]
    const cleanName = splitted[1]
    return {
      name: cleanName,
      alias,
    }
  }

  // fields of the main entity don't have any alias
  return {
    name: fieldName,
    alias: '',
  }
}
